import React from "react";
import {
  Users
} from "../../_metronic/_partials";

export function UsersPage() {
  return <Users />;
}
